import { useCallback, useEffect, useRef, useState } from "react";

export function usePdfBlob(load: () => Promise<Blob>) {
  const [url, setUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const current = useRef<string | null>(null);
  const loadRef = useRef(load);
  loadRef.current = load;
  const seq = useRef(0);

  const refresh = useCallback(() => {
    const mine = ++seq.current;
    setLoading(true);
    setError(null);
    loadRef.current().then(
      (blob) => {
        if (mine !== seq.current) return;
        const next = URL.createObjectURL(blob);
        if (current.current) URL.revokeObjectURL(current.current);
        current.current = next;
        setUrl(next);
        setLoading(false);
      },
      (e: unknown) => {
        if (mine !== seq.current) return;
        setError(e instanceof Error ? e.message : "The preview could not be rendered.");
        setLoading(false);
      },
    );
  }, []);

  useEffect(() => {
    refresh();
    return () => {
      seq.current += 1;
      if (current.current) URL.revokeObjectURL(current.current);
      current.current = null;
    };
  }, [refresh]);

  return { url, loading, error, refresh };
}
